import { X } from "lucide-react";
import { useLocation } from "react-router-dom";
import RedirectCountdown from "../components/RedirectCountdown";
import useTranslation from "../hooks/useTranslation";

export default function PaymentLinkExpired() {
  const location = useLocation();
  const { t } = useTranslation();
  const { redirectUrl } = location.state || {};

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f5f5f5] px-6 py-14">
      <div className="flex w-full max-w-[620px] flex-col items-center gap-7">
        <section className="w-full rounded-[28px] bg-white px-8 py-10 text-center shadow-[0_10px_22px_rgba(15,23,42,0.08)] md:px-12">
          <div className="mx-auto flex h-32 w-32 items-center justify-center rounded-full bg-[#FFDADF]">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#FFBAC4]">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#FD5C63] text-white">
                <X size={28} strokeWidth={3.5} aria-hidden="true" />
              </div>
            </div>
          </div>

          <h1 className="mt-7 text-2xl font-semibold text-gray-900">{t("paymentLinkExpired.title")}</h1>
          <p className="mx-auto mt-3 max-w-[500px] text-base font-normal leading-7 text-gray-600">
            {t("paymentLinkExpired.message")}
          </p>

          <RedirectCountdown redirectUrl={redirectUrl} />
        </section>

        <div className="flex w-fit items-center gap-2 rounded-xl border border-gray-200 bg-white px-5 py-3 shadow-sm">
          <span className="text-sm font-semibold text-gray-900">{t("layout.poweredBy")}</span>
          <img src="/assets/images/logo-singapay-horizontal.png" alt="SingaPay" className="h-6 w-auto object-contain" />
          {t("layout.poweredBySuffix") && (
            <span className="text-sm font-semibold text-gray-900">{t("layout.poweredBySuffix")}</span>
          )}
        </div>
      </div>
    </main>
  );
}
